(function(){
"use strict";
var rmq=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
ready(function(){

/* mobile drawer */
var mt=document.querySelector('.menu-toggle'), dr=document.getElementById('drawer');
if(mt&&dr){
  function close(){dr.classList.remove('open');document.body.style.overflow='';}
  mt.addEventListener('click',function(){dr.classList.add('open');document.body.style.overflow='hidden';});
  dr.addEventListener('click',function(e){if(e.target.matches('.drawer__scrim,[data-close],[data-close] *'))close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
}

/* hero slideshow + parallax */
var hx=document.getElementById('hx');
if(hx){
  var slides=hx.querySelectorAll('.hx__slide'), txts=hx.querySelectorAll('.hx__txt'), hdots=hx.querySelectorAll('.hx__dots button'), hi=0, htimer;
  function hgo(n){hi=(n+slides.length)%slides.length;slides.forEach(function(s,i){s.classList.toggle('is-on',i===hi);});txts.forEach(function(t,i){t.classList.toggle('is-on',i===hi);});hdots.forEach(function(d,i){d.setAttribute('aria-current',i===hi?'true':'false');});}
  function hplay(){if(rmq||slides.length<2)return;clearInterval(htimer);htimer=setInterval(function(){hgo(hi+1);},hx.getAttribute('data-interval')*1||5500);}
  hdots.forEach(function(d,i){d.addEventListener('click',function(){hgo(i);hplay();});});
  hx.addEventListener('mouseenter',function(){clearInterval(htimer);});
  hx.addEventListener('mouseleave',hplay);
  hplay();
  if(!rmq){
    var bgs=hx.querySelectorAll('.hx__bg,.hx__img'), arts=hx.querySelectorAll('.hx__art'), hw=hx.querySelector('.hx__wrap'), ht=false;
    function hpar(){ht=false;var y=window.scrollY||window.pageYOffset;if(y>820)return;bgs.forEach(function(b){b.style.transform='translateY('+(y*0.08).toFixed(1)+'px)';});arts.forEach(function(a){a.style.transform='translateY('+(y*0.22).toFixed(1)+'px)';});if(hw){hw.style.transform='translateY('+(y*0.05).toFixed(1)+'px)';hw.style.opacity=Math.max(0,1-y/680);}}
    window.addEventListener('scroll',function(){if(!ht){ht=true;requestAnimationFrame(hpar);}},{passive:true});hpar();
  }
}

/* product filter */
document.querySelectorAll('[data-filterset]').forEach(function(set){
  var chips=set.querySelectorAll('.chip'), grid=set.querySelector('.grid'), cards=grid?grid.querySelectorAll('.card'):[], empty=set.querySelector('[data-empty]');
  chips.forEach(function(c){c.addEventListener('click',function(){
    chips.forEach(function(x){x.setAttribute('aria-pressed','false');});c.setAttribute('aria-pressed','true');
    var f=c.getAttribute('data-f'),shown=0;
    cards.forEach(function(card){var ok=f==='all'||(' '+card.getAttribute('data-cat')+' ').indexOf(' '+f+' ')>-1;card.hidden=!ok;if(ok)shown++;});
    if(empty)empty.hidden=shown>0;
  });});
});

/* room pins */
document.querySelectorAll('[data-room]').forEach(function(room){
  var pins=room.querySelectorAll('.pin'), items=room.querySelectorAll('.ritem');
  function sel(i){pins.forEach(function(p,x){p.setAttribute('aria-expanded',x===i?'true':'false');});items.forEach(function(it,x){it.classList.toggle('is-on',x===i);});}
  pins.forEach(function(p){p.addEventListener('click',function(){sel(+p.getAttribute('data-r'));});});
  items.forEach(function(it,i){it.addEventListener('click',function(){sel(i);});});
});

/* wishlist (visual) */
document.querySelectorAll('.wish').forEach(function(w){w.addEventListener('click',function(e){e.preventDefault();w.classList.toggle('on');});});

/* PDP gallery */
var stage=document.getElementById('pgStage');
if(stage){
  var imgs=stage.querySelectorAll('.pg__img'), tbs=document.querySelectorAll('.pg__t');
  function show(i){imgs.forEach(function(m,x){m.classList.toggle('on',x===i);});tbs.forEach(function(t,x){t.classList.toggle('on',x===i);});}
  tbs.forEach(function(t,i){t.addEventListener('click',function(){show(i);});});
}

/* PDP variants */
document.querySelectorAll('[data-product-form]').forEach(function(form){
  var data=form.querySelector('[data-variants]'); if(!data)return;
  var variants=JSON.parse(data.textContent||'[]');
  var sel=form.querySelector('[name="id"]'), priceEl=form.querySelector('[data-price]'), addBtn=form.querySelector('[data-add]');
  function current(){
    var chosen=[];form.querySelectorAll('.option-group').forEach(function(g){var c=g.querySelector('input:checked');if(c)chosen.push(c.value);});
    return variants.find(function(v){return (v.options||[]).join(' / ')===chosen.join(' / ');})||variants[0];
  }
  function sync(){
    var v=current();if(!v)return;
    if(sel)sel.value=v.id;
    if(priceEl)priceEl.innerHTML=v.price;
    if(addBtn){addBtn.disabled=!v.available;addBtn.querySelector('span').textContent=v.available?addBtn.getAttribute('data-label'):'Sold out';}
  }
  form.querySelectorAll('.option-group input').forEach(function(i){i.addEventListener('change',sync);});
  sync();
});

/* qty steppers */
document.querySelectorAll('.qty').forEach(function(q){
  var inp=q.querySelector('input'), d=q.querySelector('[data-dec]'), u=q.querySelector('[data-inc]');
  if(d)d.addEventListener('click',function(){inp.value=Math.max(1,(parseInt(inp.value,10)||1)-1);inp.dispatchEvent(new Event('change',{bubbles:true}));});
  if(u)u.addEventListener('click',function(){inp.value=(parseInt(inp.value,10)||1)+1;inp.dispatchEvent(new Event('change',{bubbles:true}));});
});

});
})();
